import Vue from 'vue'
import App from './App'
import router from './router'

//图表
import ECharts from 'vue-echarts'
// 手动引入 ECharts 各模块来减小打包体积
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/polar'

//import 'echarts/lib/chart/map'
//import 'echarts/lib/chart/radar'
//import 'echarts/lib/chart/scatter'
//import 'echarts/lib/chart/effectScatter'
//import 'echarts/lib/component/geo'
//import 'echarts/lib/component/legend'
//import 'echarts/lib/component/title'
//import 'echarts/lib/component/visualMap'
//import 'echarts/lib/component/dataset'
import 'echarts/map/js/world'

// 如果需要配合 ECharts 扩展使用，只需要直接引入扩展包即可
// 以 ECharts-GL 为例：
// 需要安装依赖：npm install --save echarts-gl，并添加如下引用
//import 'echarts-gl'
// 注册组件后即可使用

import echarts from "echarts"
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

Vue.component('v-chart', ECharts)

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

//粒子吸附
import VueParticles from 'vue-particles'
Vue.use(VueParticles)

//封装请求
import {handleRequest} from './utils/request'
//消息弹窗
import {msgAlert} from './utils/message'
//格式化时间
import {formatDateTime} from './utils/functions'
//初始化页面
import {initPage} from './utils/functions'
//数据分页
import {dataPage} from './utils/functions'
//数值处理
import {handleNumber} from './utils/functions'
//设置API地址
import {setApiHost} from './utils/functions'
//配置参数
import {myConfigs} from './utils/configs'
//store全局数据
import {store} from './utils/store'

//样式
import './assets/css/base.scss'

// 时间格式化
import  "./filtertime/index"


Vue.config.productionTip = false

//
Vue.prototype.$handleRequest = handleRequest;
Vue.prototype.$msgAlert = msgAlert;
Vue.prototype.$formatDateTime = formatDateTime;
Vue.prototype.$initPage = initPage;
Vue.prototype.$dataPage = dataPage;
Vue.prototype.$handleNumber = handleNumber;
Vue.prototype.$setApiHost = setApiHost;
Vue.prototype.$colors = myConfigs.colors;
Vue.prototype.$charts = myConfigs.charts;
Vue.prototype.$store = store;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js